import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex } from '../Flex/index.js';
import { Tooltip, TooltipProps } from '../Tooltip/index.js';
import { Typography } from '../Typography/index.js';

export interface AidTooltipProps extends Omit<TooltipProps, 'content'> {
  src: string;
  description: string;
  poster: string;
  title: string;
  disabled?: boolean;
}

export const AidTooltip = styled(
  forwardRef<HTMLDivElement, AidTooltipProps>(
    ({ children, src, description, poster, title, disabled = false, ...restProps }, ref) => {
      return disabled ? (
        <>{children}</>
      ) : (
        <Tooltip
          ref={ref}
          {...restProps}
          content={
            <Flex column maxWidth="95dvw" width="480px">
              <video
                autoPlay
                loop
                playsInline
                controls={false}
                height="270px"
                max-width="95dvw"
                poster={poster}
                src={src}
                style={{
                  pointerEvents: 'none',
                }}
                title={title}
                width="480px"
              >
                <img alt={title} src={poster} />
              </video>
              <Flex column padding="calc(var(--spacing-padding) * 2)">
                <Typography size="small" variant="headline">
                  {title}
                </Typography>
                <Typography color="var(--spz-sys-color-on-surface)">{description}</Typography>
              </Flex>
            </Flex>
          }
        >
          {children}
        </Tooltip>
      );
    }
  )
).withConfig({
  displayName: 'AidTooltip',
})``;

export default AidTooltip;
